import React, { createContext, useCallback, useContext, useState } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./MasterDataHelper";

const MasterDataUserUIContext = createContext();

export function useMasterDataAddUserContext() {
  return useContext(MasterDataUserUIContext);
}

export const MasterDataUserUIConsumer =
    MasterDataUserUIContext.Consumer

export function MasterDataUserUIProvider({
  masterDataUserUIEvents,
  children
}) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const setQueryParams = useCallback(nextQueryParams => {
    setQueryParamsBase(prevQueryParams => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  let initUser = {
    name: '',
    email: '',
    role: '',
    superadmin_role_uuid: '',
    password: '',
    is_active: true,
    hp: '',
    active_until: null,
};

  const value = {
    queryParams,
    setQueryParamsBase,
    setQueryParams,
    initUser,
    addNewUser: masterDataUserUIEvents.addNewUser,
    editUser: masterDataUserUIEvents.editUser,
  };

  return (
    <MasterDataUserUIContext.Provider value={value}>
      {children}
    </MasterDataUserUIContext.Provider>
  );
}
